import Page from './Page';
import BackPage from './BackPage';
import BreadCrumb from './BreadCrumb';
import PageContent from './PageContent';

Page.Title = BackPage;
Page.Content = PageContent;
Page.BreadCrumb = BreadCrumb;

export default Page;
